import { Fragment, ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Tab, Tabs, tokens } from '@cast/design-system';

import type { WorkloadView } from '../_constants';
import { useInventoryWorkloadsViewLocation } from '../_hooks/useInventoryWorkloadsViewLocation';

type InventoryViewTabItem = {
  value: WorkloadView;
  label: ReactNode;
  pathname: string;
  testId: string;
  disabled?: boolean;
  wrap?: (tab: ReactElement) => ReactElement;
};

type Props = {
  testId: string;
  items: InventoryViewTabItem[];
};

export const InventoryViewTabs = ({ testId, items }: Props) => {
  const { view, to } = useInventoryWorkloadsViewLocation();

  return (
    <Tabs
      value={view}
      testId={testId}
      sx={{
        flexShrink: 0,
        borderBottom: tokens.theme.border.structural.neutral,
        width: '100%',
        minHeight: 30,
      }}
    >
      {items.map((item) => {
        const tab = item.disabled ? (
          <Tab
            key={item.value}
            value={item.value}
            label={item.label}
            disabled
            testId={item.testId}
          />
        ) : (
          <Tab
            key={item.value}
            value={item.value}
            label={item.label}
            to={to(item.pathname)}
            component={Link}
            replace
            testId={item.testId}
          />
        );

        // Keep Tab as a direct Tabs child unless a wrap (e.g. castware tooltip) is needed.
        if (!item.wrap) {
          return tab;
        }

        return <Fragment key={item.value}>{item.wrap(tab)}</Fragment>;
      })}
    </Tabs>
  );
};
